module.exports = __webpack_public_path__ + "static/media/formats.dfd314d8.png";